import React from 'react';
import ImgUpload from '../ImgUpload/ImgUpload';

class ImgUploadInput extends React.Component {
  setImageData = (data) => {
    const { value = [], onChange } = this.props;

    let updatedData = value;
    if (Array.isArray(data.value)) {
      // 이미지 삭제 및 순서 변경
      updatedData = data.value;
    } else {
      // 이미지 추가 및 변경
      updatedData[data.path[1]] = data.value;
    }

    if (onChange) {
      onChange(updatedData);
    }
  };

  render() {
    const { value = [], ...restProps } = this.props;

    return (
      <ImgUpload
        list={[...value.filter((item) => !!item)]}
        targetPath={['tempImgList']}
        setData={this.setImageData}
        hideComponentError={true}
        {...restProps}
      />
    );
  }
}

export default ImgUploadInput;
